const setDocumentTitle = (title) => {
  document.title = title;
};

export { setDocumentTitle };

export const marketboardFontFamily = '"Arial", "ヒラギノ角ゴシック ProN", "Hiragino Kaku Gothic ProN", "メイリオ", "Meiryo", sans-serif';